import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "arrowRef",
  class: "menu-popup-arrow",
  "data-popper-arrow": ""
}

import { onMounted, onBeforeUnmount, onUpdated, ref, watch } from "vue";
import { createPopper } from "@popperjs/core/lib/popper-lite";
import type { Instance as PopperInstance } from "@popperjs/core/lib/popper-lite";
import type { Placement } from "@popperjs/core/lib/enums";
import flip from "@popperjs/core/lib/modifiers/flip";
import arrow from "@popperjs/core/lib/modifiers/arrow";
import offset from "@popperjs/core/lib/modifiers/offset";
import preventOverflow from "@popperjs/core/lib/modifiers/preventOverflow";

// TODO: add Transition, this probably requires KeepAlive to avoid glitches on v-leave


export default /*@__PURE__*/_defineComponent({
  __name: 'PopUp',
  props: {
    reference: {},
    placement: {},
    offset: {},
    show: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const popup = ref<HTMLElement | null>(null);
const popper = ref<PopperInstance | null>(null);

__expose({ popper });

const options = () => ({
  placement: props.placement ?? "auto",
  modifiers: [
    preventOverflow,
    {
      name: "preventOverflow",
    },
    flip,
    offset,
    {
      name: "offset",
      options: {
        offset: [0, props.offset ?? 0],
      },
    },
    arrow,
    {
      name: "arrow",
      options: {},
    },
  ],
});

// Always recreate popper when mounting/unmounting component
onMounted(() => {
  // console.group("onMounted");
  if (props.reference != null && popup.value != null) {
    // console.log("create popper");
    popper.value = createPopper(props.reference, popup.value, options());
  }
  // console.groupEnd();
});
onBeforeUnmount(() => {
  // console.group("onBeforeUnmount");
  // if (popper.value != null) console.log("destroy popper");
  popper.value?.destroy();
  // console.groupEnd();
});
onUpdated(() => {
  popper.value?.update();
});

// Re-attach popper when reference is changed dynamically
watch(
  () => props.reference,
  (newReference) => {
    // console.group("watch reference");
    // if (popper.value != null) console.log("destroy popper");
    popper.value?.destroy();
    if (newReference != null && popup.value != null) {
      // console.log("create popper");
      popper.value = createPopper(newReference, popup.value, options());
    }
    // console.groupEnd();
  }
);

// Manage state when showing/hiding
watch(
  () => props.show,
  (newShow) => {
    const resolvedShow = newShow ?? true;

    // Enable/disable the event listeners (https://popper.js.org/docs/v2/tutorial/#performance)
    popper.value?.setOptions((opts) => ({
      ...opts,
      modifiers: [
        ...(opts.modifiers || []),
        { name: "eventListeners", enabled: resolvedShow },
      ],
    }));

    if (resolvedShow) popper.value?.update();
  }
);

// Update options on change
watch(
  () => [props.offset, props.placement],
  () => {
    popper.value?.setOptions(options());
  }
);

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref_key: "popup",
    ref: popup,
    class: "menu-popup"
  }, [
    _createElementVNode("div", _hoisted_1, null, 512),
    _renderSlot(_ctx.$slots, "default", {
      forceUpdate: () => popper.value?.update()
    })
  ], 512)), [
    [_vShow, _ctx.show]
  ])
}
}

})